import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ContentAdd, MenuClose, NoticeLoading } from '@fs/zion-icon'
import { useUser } from '@fs/zion-user'
import PillButton from './PillButton'
import { PlaylistContext } from './PlaylistContext'
import { useChatOverlayContext } from './chat/ChatOverlayProvider'

export default function AddToPlaylistButtonLarge({ isInPlaylist, contentUUID, isSeries, ...props }) {
  const [t] = useTranslation()
  const user = useUser()
  const { setIsOpen } = useChatOverlayContext()
  const [pending, setPending] = useState(false)
  const { addPlaylistItem, removePlaylistItem } = useContext(PlaylistContext)
  const handleClick = (e) => {
    e.preventDefault()
    e.stopPropagation()
    e.preventDefault()

    if (!user.signedIn) {
      setIsOpen(true)
      return false
    }

    setPending(true)

    if (isInPlaylist) {
      return removePlaylistItem({ contentUUID }).then(() => setPending(false))
    }
    return addPlaylistItem({ contentUUID, type: isSeries ? 'series' : 'session' }).then(() => setPending(false))
  }

  let Icon = isInPlaylist ? MenuClose : ContentAdd
  if (pending) Icon = NoticeLoading

  return (
    <PillButton onClick={handleClick} Icon={Icon} emphasis={isInPlaylist ? 'special' : 'high'} {...props}>
      {isInPlaylist
        ? t('series.remove-from-playlist.action', 'Remove from playlist')
        : t('series.add-to-playlist.action', 'Add to Playlist')}
    </PillButton>
  )
}
